import WebsiteManager from "Components/_PageComponents/WebsiteManager/WebsiteManager";
import { defaultProps } from "Components/_PageComponents/WebsiteManager/defaultProps";

export default function GPTQAWebsiteManager() {
  return <WebsiteManager {...defaultProps} />;
}
